<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("SERVICE.INFO") }}</h4>
    </div>
    <v-spacer />
    <div class="grid-body p-3 border-top-unset mb-3" v-if="!isLoading">
      <v-form ref="formInfo" lazy-validation>
        <div id="service-detail">
          <v-row>
            <v-col sm="12">
              <v-tabs v-model="tab" class="pl-0">
                <v-tab>{{ $t("DEFAULT") }}</v-tab>
                <v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab" class="mt-3">
                <v-tab-item>
                  <label class="label-input">{{ $t("SERVICE.NAME") }} *</label>
                  <v-text-field
                    v-model="editedItem.nameVi"
                    v-on:keyup="updateRoomTitle(editedItem.nameVi)"
                    :rules="ruleName"
                    outlined
                    dense
                    counter
                    maxlength="80"
                    class="input-counter"
                  >
                  </v-text-field>
                  <p
                    v-if="required_nameVi && editedItem.nameVi == ''"
                    class="mt-2 text-danger"
                  >
                    {{ $t("SERVICE.NAME") }} {{ $t("SERVICE.NOT_EMPTY") }}
                  </p>
                  <label class="label-input mt-3">{{
                    $t("SERVICE.DESCRIPTION_INFO_DEFAULT")
                  }}</label>
                  <v-textarea
                    :rows="6"
                    v-model="editedItem.descriptionVi"
                    v-on:keyup="updateRoomDescription(editedItem.descriptionVi)"
                    outlined
                    :rules="ruleDescNotRequired"
                    dense
                    counter="3000"
                    maxlength="3000"
                    class="input-counter"
                  >
                  </v-textarea>
                </v-tab-item>
                <v-tab-item v-for="code in codeLangs" :key="code">
                  <label class="label-input">{{ $t("SERVICE.NAME") }} *</label>
                  <v-text-field
                    v-model="editedItem.serviceStaticI18ns.find((x) => x.lang == code).name" :rules="ruleName"
                    outlined dense counter maxlength="80" class="input-counter"
                  >
                  </v-text-field>
                  <label class="label-input mt-3">{{
                    $t("SERVICE.DESCRIPTION_INFO")
                  }}</label>
                  <v-textarea :rows="3" v-model="editedItem.serviceStaticI18ns.find((x) => x.lang == code).description"
                    outlined :rules="ruleDescNotRequired" counter="3000" maxlength="3000" class="input-counter"
                  />
                </v-tab-item>
              </v-tabs-items>

              <div>
                <label class="label-input mt-3">{{ $t("SERVICE.CODE") }} *</label>
                <v-text-field
                  v-model="editedItem.serviceCode"
                  @change.native="checkServiceCodeExit"
                  :rules="ruleCode"
                  outlined
                  dense
                  :disabled="editedItem.id ? true : false"
                  counter
                  maxlength="20"
                  class="input-counter code"
                >
                </v-text-field>
                <div
                  v-if="isServiceCodeExit"
                  class="v-messages theme--light error--text"
                  role="alert"
                >
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ $t("SERVICE.CODE") }} {{ $t("SERVICE.HAS_EXITS") }}
                    </div>
                  </div>
                </div>
                <v-checkbox
                  v-model="editedItem.status"
                  :label="$t('ACTIVE')"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
          <v-divider />
          <label class="label-title">{{ $t("SERVICE.PRICE") }}</label>
          <div class="tbl-price mt-3">
            <table>
              <thead>
                <tr>
                  <th>
                    <div class="header-wrapper vertical-divider text-center">
                      <span class="text-center">{{ $t("SERVICE.COPPY") }}</span>
                    </div>
                  </th>
                  <th v-for="(item, index) in daysOfWeek" :key="index" :class="item.code">
                    <div class="header-wrapper vertical-divider text-center">
                      <span class="text-center">{{ item.value }}</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="center">
                    <span
                      class="icon icon-notifications-ic-copy-3 btn-multi-copy"
                      @click="copyFirstValue(editedItem['priceSunday'])"
                      style="font-size: 24px !important"
                    ></span>
                  </td>
                  <td v-for="(date, index) in daysOfWeek" :key="index">
                    <div class="price-day">
                      <v-text-field
                        @keydown="keyCurrencyDown($event, currencyCode)"
                        :options="currencyCode === 'VND' ? priceOptionsVi : priceOptionsEn"
                        outlined
                        dense
                        :value="computedPrice(date).get()"
                        @input="handleInput($event, date.code)"
                        v-bind:prefix="prefixCurrency"
                        v-bind:suffix="suffixCurrency"
                        :key="`${date.code}_${reloadKey}`"
                        :ref="`input_${date.code}`"
                      ></v-text-field>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <v-divider />
          <!-- Don vi tinh -->
          <v-row class="mt-3">
            <v-col sm="4">
              <p class="mb-1">{{ $t("SERVICE.UNIT") }} *</p>
              <v-select
                outlined
                dense
                item-text="value"
                item-value="id"
                :items="unit"
                v-model="editedItem.unitVi"
                :rules="ruleRequied"
              ></v-select>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <label class="label-title">{{ $t("SERVICE.TIME_APPLY") }}</label>
        <v-row>
          <v-col>
            <p class="mt-2">{{ $t("SERVICE.DAY_APPLY") }}</p>
            <v-layout wrap>
              <v-chip-group v-model="weekend" column multiple active-class="primary">
                <v-chip v-for="date in dow" :value="date.date" class="chip-date">
                  {{ date.text }}
                </v-chip>
              </v-chip-group>
            </v-layout>
          </v-col>
        </v-row>
        <v-divider />
        <div class="d-flex">
          <div class="pr-3" style="min-width: 400px">
            <v-radio-group
              v-model="editedItem.schedulingType"
              mandatory
              @change="($event) => changeSchedulingType($event)"
            >
              <v-radio
                :label="item.label"
                :value="item.code"
                v-for="item in optionSchedulingType"
              ></v-radio>
            </v-radio-group>
          </div>
          <div>
            <div
              v-if="editedItem.schedulingType === 7"
              class="border-left p-3 d-desscription h-100"
            >
              <b>{{ $t("_ACTIVITY.APPLY_DATE") }}</b>
              <v-layout wrap class="my-2">
                <v-chip-group
                  v-model="schedulingCustomerSelect"
                  column
                  multiple
                  active-class="primary"
                >
                  <v-chip
                    v-for="date in optionSchedulingCustomer[0].children"
                    :value="date.id"
                    class="chip-date"
                  >
                    {{ date.id < 10 ? "0" + date.id : date.id }}
                  </v-chip>
                </v-chip-group>
              </v-layout>
              <i class="fs-10"
                >{{$t('NIGHT_14_DESCRIPTION')}}</i
              >
            </div>
            <div
              v-if="editedItem.schedulingType === 8"
              class="border-left p-3 d-desscription h-100"
            >
              <b>{{ $t("SERVICE.TIME_APPLY") }}</b>
              <treeselect
                class="mt-2"
                :options="optionSchedulingCustomer"
                v-model="schedulingCustomer"
                :default-expand-level="1"
                :clearable="false"
                :required="true"
                :multiple="false"
                :placeholder="$t('_ACTIVITY.APPLY_DATE')"
                @input="editedItem.schedulingCustomer = schedulingCustomer"
                :class="schedulingCustomer ? '' : 'border-danger'"
              >
              </treeselect>
            </div>
            <div
              v-if="editedItem.schedulingType === 9"
              class="border-left p-3 d-desscription h-100"
            >
              <b>{{ $t("CUSTOM") }}</b>
             <v-row class="mt-2">
              <v-col cols="6">
                <v-row>
                  <v-col class="p-0">
                    <v-subheader>{{$t('STARTING_FROMM_NIGHT')}}</v-subheader>
                  </v-col>
                  <v-col cols="5" class="p-0">
                    <treeselect
                      :options="optionSchedulingStart"
                      v-model="editedItem.schedulingStart"
                      :default-expand-level="1"
                      :clearable="false"
                      :required="true"
                      :multiple="false"
                      :placeholder="$t('NIGHT')"
                      @input="changeOptionSchedulingStop()"
                      :class="editedItem.schedulingStart ? '' : 'border-danger'"
                    >
                    </treeselect>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="p-0">
                    <v-subheader>{{$t('ENDS_ON_NIGHT')}}</v-subheader>
                  </v-col>
                  <v-col cols="5" class="p-0">
                    <treeselect
                      :options="optionSchedulingStop"
                      v-model="editedItem.schedulingStop"
                      :default-expand-level="1"
                      :clearable="false"
                      :required="true"
                      :multiple="false"
                      :placeholder="$t('NIGHT')"
                      :class="editedItem.schedulingStop ? '' : 'border-danger'"
                    >
                    </treeselect>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="p-0">
                    <v-subheader>{{$t('USE_CYCLE')}}</v-subheader>
                  </v-col>
                  <v-col cols="5" class="p-0">
                    <vuetify-number
                      :options="percentOptionsVi"
                      outlined="true"
                      dense
                      v-model="editedItem.schedulingStep"
                      :rules="[value => value > 0 || this.$t('DATA_INPUT_INVALID')]"
                    >
                    </vuetify-number>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="p-0">
                    <v-subheader>{{$t('NUMBER_OF_REPETITION')}}</v-subheader>
                  </v-col>
                  <v-col cols="5" class="p-0">
                    <vuetify-number
                      :options="percentOptionsVi"
                      outlined="true"
                      dense
                      v-model="editedItem.schedulingCustomer"
                      :rules="[value => value > 0 || this.$t('DATA_INPUT_INVALID')]"
                    ></vuetify-number>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="pl-5">
                <ins>{{$t('EXAMPLE')}}: </ins>
                <div class="fs-12" v-html="$t('FOR_EXAMPLE_SERVICE')">
                </div>
              </v-col>
             </v-row>
            </div>
            <div
              v-if="editedItem.schedulingType === 3"
              class="border-left p-3 d-desscription h-100"
            >
              <b>{{ $t("CUSTOM") }}</b>
              <v-row class="mt-2">
                <v-col class="p-0" cols="3">
                  <v-subheader>{{$t('NUMBER_OF_REPETITION_DETAIL')}}</v-subheader>
                </v-col>
                <v-col cols="5" class="p-0">
                  <vuetify-number
                    :options="percentOptionsVi"
                    outlined="true"
                    dense
                    v-model="editedItem.schedulingStep"
                    :rules="[
                      (value) => parseFloat(value) >= 1 || this.$t('DATA_INPUT_INVALID'),
                    ]"
                  >
                  </vuetify-number>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="p-0" cols="3">
                  <v-subheader>{{$t('STARTING_FROMM_NIGHT')}} (Y)</v-subheader>
                </v-col>
                <v-col cols="5" class="p-0">
                  <treeselect
                    :options="optionSchedulingStart"
                    v-model="editedItem.schedulingStart"
                    :default-expand-level="1"
                    :clearable="false"
                    :required="true"
                    :multiple="false"
                    :placeholder="$t('NIGHT')"
                    :class="editedItem.schedulingStart ? '' : 'border-danger'"
                  >
                  </treeselect>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <v-divider />
        <div class="btn-bottom">
          <v-btn depressed class="mr-5" @click="back">{{ $t("BACK") }}</v-btn>
          <v-btn color="primary" class="pl-10 pr-10 btn-save" @click="save" :loading="loading">{{
            $t("SAVE")
          }}</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import DatePickerCustom from "@/components/Utils/DatePicker.vue";
import MultiSelect from "@/components/Utils/MultiSelect.vue";
import { VueEditor } from "vue2-editor";
//import Multiselect from "vue-multiselect";
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { servicePackageService } from "@/_services/Service/service.service.js";
import { serviceCombo } from "@/_services/Combo/Combo.service.js";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import moment, { max } from "moment";
import VueNumeric from "vue-numeric";

import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { DAYS_OF_WEEK } from "@/_helpers/config.js";

import { _validateFormI18n, _alert, _resetErrorState } from "@/_helpers/function.js";
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { REGEX_SERVICE_CODE } from "@/_helpers/constant.js";
import { SPD_ERROR } from "@/_helpers/config.js";
import Textarea from "@/components/Utils/Textarea.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

//
export default {
  components: {
    //Multiselect,
    datePicker: DatePicker,
    "date-picker": DatePickerCustom,
    "input-text": Input,
    "select-text": Select,
    multiSelect: MultiSelect,
    VueEditor,
    "input-textarea": Textarea,
    "delete-dialog": DeleteDialog,
    DateRangePicker,
    VueNumeric,
    Treeselect,
  },
  data() {
    return {
      isLoading: true,
      required_name: false,
      required_code: false,
      required_code_length: false,
      required_code_exits: false,
      required_nameVi: false,
      currentDate: moment(new Date()).format("YYYY-MM-DD"),
      editedItem: {
        status: true,
        bitWeekDays: 127,
        serviceCode: "",
        defaultImageId: "",
        priceFriday: 0,
        priceMonday: 0,
        priceSaturday: 0,
        priceSunday: 0,
        priceThursday: 0,
        priceTuesday: 0,
        priceWednesday: 0,
        serviceStaticI18ns: [],
        nameVi: "",
        unitVi: "",
        descriptionVi: "",
        schedulingType: 0,
        schedulingStart: 1,
        schedulingStop: -1
      },
      dow: DAYS_OF_WEEK,
      weekend: [],
      defaultWeekend: [],
      // tmp: null,
      listOfRooms: [],
      listOfChannels: [
        { id: 1, name: "Booking Engine" },
        // { id: 2, name: 'OneInventory'},
      ],
      daysOfWeek: [
        { code: "priceSunday", value: this.$t("SUNDAY") },
        { code: "priceMonday", value: this.$t("MONDAY") },
        { code: "priceTuesday", value: this.$t("TUESDAY") },
        { code: "priceWednesday", value: this.$t("WEDNESDAY") },
        { code: "priceThursday", value: this.$t("THURSDAY") },
        { code: "priceFriday", value: this.$t("FRIDAY") },
        { code: "priceSaturday", value: this.$t("SATURDAY") },
      ],
      showImageOverlay: false,
      fileUpload: "",
      imagePreview: "",
      isNoThumb: false,
      currencyCode: JSON.parse(localStorage.getItem("currency")),
      tab: null,
      sysLang: this.$i18n.locale,
      lang: "vi",
      isServiceCodeExit: false,
      notApplyDates: [],
      notApplyDatesStay: [],
      specialDaysPrice: [],
      selectAllPlans: false,
      imageFormData: "",
      errors: SPD_ERROR,
      dialog: false,
      originalSpecialDaysPrice: [],
      errorApiSpecialService: false,
      errorfromBook: false,
      errortoBook: false,
      errorfromStaying: false,
      errortoStaying: false,
      errorname_vi: false,
      errorname_en: false,
      isImageLarge: false,
      //

      listOfChannels: [],
      selectAllChannel: false,
      listOfMarkets: [],
      selectAllMarket: false,
      applyAllChannel: "ALL",
      applyAllMarket: "ALL",
      isEmptyDefaultTitle: false,
      // roomRatePackageSpecials: [],
      unit: [],
      currentDatePicker: moment().startOf("day").format("YYYY-MM-DD"),
      optionSchedulingType: [
        {
          code: 0,
          label: this.$t('SCHEDULINGTYPE_0'),
        },
        {
          code: 1,
          label: this.$t('SCHEDULINGTYPE_1'),
        },
        {
          code: 2,
          label: this.$t('SCHEDULINGTYPE_2'),
        },
        {
          code: 3,
          label: this.$t('SCHEDULINGTYPE_3'),
        },
        {
          code: 4,
          label: this.$t('SCHEDULINGTYPE_4'),
        },
        {
          code: 5,
          label: this.$t('SCHEDULINGTYPE_5'),
        },
        {
          code: 6,
          label: this.$t('SCHEDULINGTYPE_6'),
        },
        {
          code: 7,
          label: this.$t('SCHEDULINGTYPE_7'),
        },
        {
          code: 8,
          label: this.$t('SCHEDULINGTYPE_8'),
        },
        {
          code: 9,
          label: this.$t('SCHEDULINGTYPE_9'),
        },
      ],
      optionSchedulingStart: [
        {
          id: 1,
          label: 1,
        },
        {
          id: 2,
          label: 2,
        },
        {
          id: 3,
          label: 3,
        },
        {
          id: 4,
          label: 4,
        },
        {
          id: 5,
          label: 5,
        },
        {
          id: 6,
          label: 6,
        },
        {
          id: 7,
          label: 7,
        },
        {
          id: -2,
          label: this.$t('BEFORE_THE_LAST_NIGHT'),
        },
        {
          id: -1,
          label: this.$t('LAST_NIGHT'),
        },
      ],
      optionSchedulingStop: [
        {
          id: 1,
          label: 1,
          isDisabled: false,
        },
        {
          id: 2,
          label: 2,
          isDisabled: false,
        },
        {
          id: 3,
          label: 3,
          isDisabled: false,
        },
        {
          id: 4,
          label: 4,
          isDisabled: false,
        },
        {
          id: 5,
          label: 5,
          isDisabled: false,
        },
        {
          id: 6,
          label: 6,
          isDisabled: false,
        },
        {
          id: 7,
          label: 7,
          isDisabled: false,
        },
        {
          id: -2,
          label: this.$t('BEFORE_THE_LAST_NIGHT'),
          isDisabled: false,
        },
        {
          id: -1,
          label: this.$t('LAST_NIGHT'),
          isDisabled: false,
        },
      ],
      optionSchedulingCustomer: [
        {
          id: -1,
          label: this.$t("ALL"),
          children: [],
        },
      ],
      schedulingCustomer: 1,
      schedulingCustomerSelect: [],
      percentOptionsVi: {
        suffix: "",
        locale: "vi",
        length: 3,
        precision: 0,
      },
      schedulingStep: 1,
      languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : [],
      loading: false,
      timeout: null,
      reloadKey: 0,
    };
  },
  created() {
    this.codeLangs.forEach(e => {
      this.editedItem.serviceStaticI18ns.push({
          description: "",
          lang: e,
          name: ""
      })
    });
    this.currencyCode = this.priceOptionsVi.suffix;
    for (let index = 1; index <= 14; index++) {
      this.optionSchedulingCustomer[0].children.push({
        id: index,
        label: this.$tc("NIGHT_CAP", index),
      });
    }
    this.initialize();
  },
  computed: {
    computedPrice() {
      return (date) => ({
        get: () => {
          return this.convertDecimalViaLocal(this.editedItem[date.code]) || "";
        },
        set: (value) => {
          this.$set(this.editedItem, date.code, value);
        }
      });
    },
    yesterday() {
      var d = new Date();
      return d.setDate(d.getDate() - 1);
    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_SERVICE_CODE() {
      return REGEX_SERVICE_CODE;
    },
  },
  watch: {
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.editedItem.serviceStaticI18ns.find(
        (x) => x.lang == value
      ).description;
    },
    dayApplyInWeekSelected() {
      // let tmp_applyDay = [0,0,0,0,0,0,0];
      // this.dayApplyInWeekSelected.forEach(function(value) {
      //   tmp_applyDay[value-1] = 1;
      // });
      // this.editedItem.applyDay = tmp_applyDay.toString().replace(/,/g, '');
      // this.daysOfWeek.forEach((element, index) => {
      //   if (this.editedItem.applyDay.charAt(index) === '0'){
      //     this.editedItem[element.code] = 0;
      //   }
      // });
    },
    weekend(value) {
      let tmp = [0, 0, 0, 0, 0, 0, 0];
      value.forEach(function (element) {
        if (element === "MON") {
          tmp[0] = 1;
        }

        if (element === "TUE") {
          tmp[1] = 1;
        }

        if (element === "WED") {
          tmp[2] = 1;
        }

        if (element === "THU") {
          tmp[3] = 1;
        }

        if (element === "FRI") {
          tmp[4] = 1;
        }

        if (element === "SAT") {
          tmp[5] = 1;
        }

        if (element === "SUN") {
          tmp[6] = 1;
        }
      });

      this.editedItem.bitWeekDays = parseInt(tmp.join(""), 2);
    },
    schedulingCustomerSelect(value) {
      let tmp = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      value.forEach(function (element) {
        tmp[element + 1] = 1;
      });
      this.editedItem.schedulingCustomer = parseInt(tmp.join(""), 2);
    },
  },
  mounted() {},
  methods: {
    handleInput(value, code) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const newVal = this.setCurrency(value);
        this.computedPrice({ code }).set(newVal);
        this.reloadKey += 1;
        this.$nextTick(() => {
          const inputRef = this.$refs[`input_${code}`];
          if (inputRef && inputRef[0]) {
            inputRef[0].focus();
          }
        });
      }, this.timeOutChange(value));
    },
    _moment: moment,
    currentDateLocal() {
      let today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //As January is 0.
      var yyyy = today.getFullYear();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      return yyyy + "-" + mm + "-" + dd;
    },
    changeSchedulingType(changeSchedulingType) {
      switch (changeSchedulingType) {
        case 0:
          this.editedItem.schedulingStart = 1;
          this.editedItem.schedulingStop = -1;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = 1;
          break;
        case 1:
          this.editedItem.schedulingStart = 1;
          this.editedItem.schedulingStop = 1;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = 1;
          break;
        case 2:
          this.editedItem.schedulingStart = -1;
          this.editedItem.schedulingStop = -1;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = 1;
          break;
        case 3:
          this.editedItem.schedulingStart = 1;
          this.editedItem.schedulingStop = -1;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = -1;
          break;
        case 4:
          this.editedItem.schedulingStart = 2;
          this.editedItem.schedulingStop = -1;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = -1;
          break;
        case 5:
          this.editedItem.schedulingStart = 1;
          this.editedItem.schedulingStop = -2;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = -1;
          break;
        case 6:
          this.editedItem.schedulingStart = 2;
          this.editedItem.schedulingStop = -2;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = -1;
          break;
        case 7:
          this.editedItem.schedulingStart = 1;
          this.editedItem.schedulingStop = -1;
          this.editedItem.schedulingStep = 1;
          this.schedulingCustomerSelect = [];
          break;
        case 8:
          this.editedItem.schedulingStart = 1;
          this.editedItem.schedulingStop = -1;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = this.schedulingCustomer;
          break;

        default:
          this.editedItem.schedulingStart = 1;
          this.editedItem.schedulingStop = -1;
          this.editedItem.schedulingStep = 1;
          this.editedItem.schedulingCustomer = 1;
          break;
      }
    },
    changeOptionSchedulingStop() {
      // if (this.editedItem.schedulingStart)
      this.optionSchedulingStop.forEach((e) => {
        if (this.editedItem.schedulingStart > 0) {
          if (e.id > 0 && e.id <= this.editedItem.schedulingStart) {
            e.isDisabled = true;
          } else {
            e.isDisabled = false;
          }
        } else if (this.editedItem.schedulingStart === -1) {
          if (e.id !== -1) {
            e.isDisabled = true;
          } else {
            e.isDisabled = false;
          }
        } else {
          if (e.id !== -1 && e.id !== -2) {
            e.isDisabled = true;
          } else {
            e.isDisabled = false;
          }
        }
      });
    },
    updateRoomTitle(value) {
      if (value.length > 0) {
        this.isEmptyDefaultTitle = false;
        for (let i = 0; i < this.editedItem.serviceStaticI18ns.length; i++) {
          this.editedItem.serviceStaticI18ns[i].name = value;
        }
      } else {
        this.isEmptyDefaultTitle = true;
      }
    },
    updateRoomDescription(value) {
      for (let i = 0; i < this.editedItem.serviceStaticI18ns.length; i++) {
        this.editedItem.serviceStaticI18ns[i].description = value;
      }
    },
    async initialize() {
      _resetErrorState(this.errors);
      this.isLoading = true;
      await servicePackageService.getUnit().then((res) => {
        this.unit = res.data.map((x) => {
          return {
            id: x.lookupItemCode,
            value: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
          };
        });
        this.editedItem.unitVi = this.unit.length > 0 ? this.unit[0].id : null;
      });
      //
      let id = this.$route.params.id;
      if (id != 0) {
        serviceCombo.getDetailService(id).then((res) => {
          this.editedItem = res.data;
          if (this.editedItem.schedulingType === 7) {
            const arrCustom = this.convertFromBinaryToListDay(
              this.editedItem.schedulingCustomer
            );

            var arr = [];
            arrCustom.forEach(function (element, index) {
              if (element == 1 && index > 1) {
                arr.push(index - 1);
              }
            });
            this.schedulingCustomerSelect = arr;
          }
          if (this.editedItem.schedulingType === 8) {
            this.schedulingCustomer = this.editedItem.schedulingCustomer;
          }
          this.imagePreview = this.editedItem.imageUrl;

          // Chuyển từ binary sang select
          this.defaultWeekend = this.convertFromBinaryToListSelection(
            res.data.bitWeekDays
          );
          var tmp = [];
          this.defaultWeekend.forEach(function (element, index) {
            if (element == 1) {
              if (index == 0) {
                tmp.push("MON");
              }
              if (index == 1) {
                tmp.push("TUE");
              }
              if (index == 2) {
                tmp.push("WED");
              }
              if (index == 3) {
                tmp.push("THU");
              }
              if (index == 4) {
                tmp.push("FRI");
              }
              if (index == 5) {
                tmp.push("SAT");
              }
              if (index == 6) {
                tmp.push("SUN");
              }
            }
          });
          this.weekend = tmp;
        });
      } else {
        this.editedItem = {
          status: true,
          bitWeekDays: 127,
          serviceCode: "",
          defaultImageId: "",
          priceFriday: 0,
          priceMonday: 0,
          priceSaturday: 0,
          priceSunday: 0,
          priceThursday: 0,
          priceTuesday: 0,
          priceWednesday: 0,
          serviceStaticI18ns: [],
          nameVi: "",
          unitVi: "",
          descriptionVi: "",
          schedulingType: 0,
          schedulingStep: 1,
          schedulingStart: 1,
          schedulingStop: 1,
          schedulingCustomer: 1,
        };
        this.codeLangs.forEach(e => {
          this.editedItem.serviceStaticI18ns.push({
              description: "",
              lang: e,
              name: ""
          })
        });
        // Chuyển từ binary sang select
        this.defaultWeekend = this.convertFromBinaryToListSelection(
          this.editedItem.bitWeekDays
        );
        var tmp = [];
        this.defaultWeekend.forEach(function (element, index) {
          if (element == 1) {
            if (index == 0) {
              tmp.push("MON");
            }
            if (index == 1) {
              tmp.push("TUE");
            }
            if (index == 2) {
              tmp.push("WED");
            }
            if (index == 3) {
              tmp.push("THU");
            }
            if (index == 4) {
              tmp.push("FRI");
            }
            if (index == 5) {
              tmp.push("SAT");
            }
            if (index == 6) {
              tmp.push("SUN");
            }
          }
        });
        this.weekend = tmp;
      }

      // Dong bo tich chon cac phong
      this.roomTyleApplied = this.editedItem.plans;
      salePackageService.getRoomRate("EZ_BE").then((res) => {
        if (res.responseCode == 0) {
          this.listOfRooms = res.data;
        }
      });
      this.isLoading = false;
    },
    checkServiceCodeExit() {
      if (this.editedItem.serviceCode.length < 2) {
        this.required_code_length = true;
      } else {
        this.required_code_length = false;
        servicePackageService
          .checkServiceCode(this.editedItem.serviceCode.toUpperCase())
          .then((res) => {
            if (res.responseCode == 1) {
              this.isServiceCodeExit = true;
              this.required_code_exits = true;
            } else {
              this.isServiceCodeExit = false;
              this.required_code_exits = false;
            }
          });
      }
    },
    validateAndFocusTab() {
        if (!this.editedItem.nameVi) {
            this.tab = 0;
            return;
        }

        for (let i = 0; i < this.codeLangs.length; i++) {
            const langCode = this.codeLangs[i];
            const roomLang = this.editedItem.serviceStaticI18ns.find(x => x.lang === langCode);

            if (!roomLang || !roomLang.name) {
                this.tab = i + 1;
                return;
            }
        }
    },
    async save() {
      await this.validateAndFocusTab();
      await this.$nextTick();
      let form_validate = this.$refs.formInfo.validate();
      if (!form_validate) {
          this.$store.commit("alert/display", {
              message: this.$t("_VALIDATE.REQUIRED"),
              error: true,
              success: false,
          });
          const el = document.querySelector(".v-messages.error--text:first-of-type");
          el.scrollIntoView();
          this.$nextTick(() => {
              const el = document.querySelector(".v-messages.error--text");
              if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
          });
          return false;
      }
      if (!this.$refs.formInfo.validate()) return false;
      this.required_name = false;
      this.required_nameVi = false;
      if (!this.editedItem.nameVi) {
        this.required_nameVi = true;
      }
      // this.required_code = false;
      let element = document.querySelector(".btn-save");
      this.editedItem.serviceStaticI18ns.forEach((e) => {
        if (e.name == "") {
          this.required_name = true;
          if (e.lang == "vi") {
            this.errorname_vi = true;
          } else if (e.lang == "en") {
            this.errorname_en = true;
          }
        } else {
          this.errorname_en = false;
          this.errorname_vi = false;
        }
      });
      if (!this.errorname_vi && this.errorname_en) {
        this.tab = 1;
      } else {
        this.tab = 0;
      }
      if (this.editedItem.serviceCode.length < 2) {
        this.required_code_length = true;
      }

      if (
        !this.required_name &&
        !this.required_code_exits &&
        !this.required_code_length &&
        !this.required_nameVi &&
        this.editedItem.schedulingStart &&
        this.editedItem.schedulingStop
      ) {
        this.isImageLarge = false;
        this.loading = true;
        if (this.editedItem.id) {
          let tmp = Object.assign({}, this.editedItem);
          delete tmp.defaultImageThumbUrl;
          delete tmp.defaultImageId;
          await serviceCombo.updateService(tmp).then((res) => {
            _alert(res, this.$t(res.data), true);
            if (res.responseCode != 0) {
              element.disabled = false;
            }
            this.loading = false;
          });
        } else {
          this.editedItem.serviceCode = this.editedItem.serviceCode.toUpperCase();
          let tmp = Object.assign({}, this.editedItem);
          delete tmp.defaultImageThumbUrl;
          delete tmp.defaultImageId;
          await serviceCombo.createService(tmp).then((res) => {
            _alert(res, this.$t(res.data), false);
            if (res.responseCode != 0) {
              element.disabled = false;
            } else {
              this.$router.back();
            }
            this.loading = false;
          });
        }
      } else {
        this.$store.commit("alert/display", {
          message: this.$t("MISSING_FIELD"),
          error: true,
          success: false,
        });
      }
    },
    back() {
      this.$router.back();
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    convertFromBinaryToListDay(number) {
      let output = parseInt(number, 10).toString(2);

      while (output.length < 16) {
        output = "0" + output;
      }
      return output.split("").map((e) => {
        return +e;
      });
    },
    copyFirstValue(value) {
      this.daysOfWeek.forEach((e) => {
      this.editedItem[e.code] = value;
    });
    },
    clickSelectAllPlans() {
      if (this.selectAllPlans) {
        this.listOfRooms.forEach((e) => {
          this.editedItem.plans.push(e.id);
        });
      } else {
        this.editedItem.plans = [];
      }
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>
<style lang="scss" scoped>
#service-detail {
  .square {
    position: relative;
    flex-basis: 100%;
    box-sizing: border-box;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    &::before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    & .square-content {
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  .day-apply-in-week {
    .v-select__selections {
      input {
        display: none;
      }
    }
  }

  .add-not-apply-date {
    background-color: #cdcdcc;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;

    // outline: none;
    i {
      font-size: 18px;
    }
  }

  .include-tax {
    span {
      font-size: 13px;
      margin-top: 3px;
      padding-right: 10px;
    }

    .v-input {
      margin-top: 0;
      padding-top: 0;
      display: inline-block;
    }
  }

  .tbl-price {
    .form-control {
      min-width: 100%;
    }
  }

  span.icon {
    display: block;
    padding-top: 15px;
    width: 100px;
    text-align: center;
  }

  .price-day {
    margin: 5px 5px 0 5px !important;
  }

  .label-price {
    display: inline-block;
    float: left;
    font-size: 14px;
    padding-right: 10px;
    padding-top: 3px;
  }

  .vue-daterange-picker {
    width: 100%;
  }

  .btn-popup-special-days-price,
  .add-not-apply-date {
    background-color: #173d8f;
    color: #fff;

    i {
      color: #fff !important;
      font-size: 18px;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  .special-service-desc {
    padding-left: 10px;
    color: red;
  }

  .priceSaturday {
    width: auto !important;
  }
}

.table-special-days-price .border-error#date-picker .v-input input {
  border-color: red;
}
</style>
